import { render, staticRenderFns } from "./AccessErrorBase.vue?vue&type=template&id=0fff32be&scoped=true&"
import script from "./AccessErrorBase.vue?vue&type=script&lang=js&"
export * from "./AccessErrorBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fff32be",
  null
  
)

export default component.exports